var SpreeAPI = {
  oauthToken: null, // user Bearer token to authorize operations for the given user
  orderToken: null // order token to authorize operations on current order (cart)
}

SpreeAPI.Storefront = {}
SpreeAPI.Platform = {}

SpreeAPI.ready = function (callback) {
  return jQuery(document).on('page:load turbolinks:load', function () {
    return callback(jQuery)
  })
}

SpreeAPI.mountedAt = function () {
  return window.SpreePaths.mounted_at
}

SpreeAPI.pathFor = function (path) {
  var locationOrigin = (window.location.protocol + '//' + window.location.hostname) + (window.location.port ? ':' + window.location.port : '')

  return this.url('' + locationOrigin + (this.mountedAt()) + path, this.url_params).toString()
}

SpreeAPI.localizedPathFor = function(path) {
  if (typeof (SPREE_LOCALE) !== 'undefined' && typeof (SPREE_CURRENCY) !== 'undefined') {
    var fullUrl = new URL(SpreeAPI.pathFor(path))
    var params = fullUrl.searchParams
    var pathName = fullUrl.pathname

    params.set('currency', SPREE_CURRENCY)

    if (pathName.match(/api\/v/)) {
      params.set('locale', SPREE_LOCALE)
    } else {
      pathName = (this.mountedAt()) + SPREE_LOCALE + '/' + path
    }
    return fullUrl.origin + pathName + '?' + params.toString()
  }
  return SpreeAPI.pathFor(path)
}

// API routes
var locationOrigin = (window.location.protocol + '//' + window.location.hostname) + (window.location.port ? ':' + window.location.port : '')
SpreeAPI.routes = {
  api_v2_storefront_cart_create: new URL('api/v2/storefront/cart', locationOrigin).toString(),
  api_v2_storefront_cart_add_item: new URL('api/v2/storefront/cart/add_item', locationOrigin).toString(),
  api_v2_storefront_cart_is_possible_to_add: new URL('api/v2/storefront/cart/is_possible_to_add', locationOrigin).toString(),
  api_v2_storefront_cart_apply_coupon_code: new URL('api/v2/storefront/cart/apply_coupon_code', locationOrigin).toString(),
  cart: new URL('cart', locationOrigin).toString(),
  api_tokens: new URL('api_tokens', locationOrigin).toString(),
  ensure_cart: new URL('ensure_cart', locationOrigin).toString(),
  cart_link: new URL('cart_link', locationOrigin).toString(),
}

// helpers
SpreeAPI.handle500error = function () {
  alert('Internal Server Error')
}

SpreeAPI.prepareHeaders = function (headers) {
  if (typeof headers === 'undefined') {
    headers = {}
  }

  // if signed in we need to pass the Bearer authorization token
  // so backend will recognize that actions are authorized in scope of this user
  if (SpreeAPI.oauthToken) {
    headers['Authorization'] = 'Bearer ' + SpreeAPI.oauthToken
  }

  // default headers, required for POST/PATCH/DELETE requests
  headers['Accept'] = 'application/json'
  headers['Content-Type'] = 'application/json'
  return headers
}

SpreeAPI.fetchApiTokens = function () {
  fetch(SpreeAPI.routes.api_tokens, {
    method: 'GET',
    credentials: 'same-origin'
  }).then(function (response) {
    switch (response.status) {
      case 200:
        response.json().then(function (json) {
          SpreeAPI.orderToken = json.order_token
          SpreeAPI.oauthToken = json.oauth_token
          SpreeAPI.apiTokensFetched = true
        })
        break
    }
  })
}

SpreeAPI.fetchCart = function () {
  return $.ajax({
    url: SpreeAPI.routes.cart_link
  }).done(function (data) {
    SpreeAPI.cartFetched = true
    return $('#link-to-cart').html(data)
  })
}

SpreeAPI.ensureCart = function (successCallback) {
  // ensure_cartにリクエストするとカートに対応する注文レコードを検索し、存在しなければ作成される。
  fetch(SpreeAPI.routes.ensure_cart, {
    method: 'POST',
    credentials: 'same-origin'
  }).then(function (response) {
    switch (response.status) {
      case 200:
        response.json().then(function (json) {
          SpreeAPI.orderToken = json.token
          successCallback()
        })
        break
    }
  })
}

export default SpreeAPI
